import {Observable, throwError} from 'rxjs';

import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {SurveyContextInvalidError, SurveyService} from '@clients/member-direct/surveys';

/**
 * This route guard checks whether we have validated the survey and
 * if that process has not yet been completed, we navigate back to
 * the survey bootstrap route to restart the process.
 */
@Injectable()
export class SurveyContextIsValidGuard implements CanActivate {
    constructor(private surveyService: SurveyService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | Observable<any> {
        // if the survey does not require IDV or the user has already
        // verified themselves, then load the route.
        if (this.surveyService.isValid()) return true;

        // todo | verify context is set and error out if not https://healthtel.atlassian.net/browse/SB-991

        const context: string = route.paramMap.get('context');
        const blockId: string | null = route.queryParamMap?.get('blockId') ?? null;
        const loadBlockOnParam: string | null = route.queryParamMap?.get('load') ?? null;
        this.router.navigate([`survey/${context}`], {
            queryParams: { blockId: blockId, load: loadBlockOnParam },
            queryParamsHandling: 'merge'  // or 'preserve' or 'replace'
        });

        return throwError(() => new SurveyContextInvalidError(route.paramMap.get('context')));
    }
}
